export const styles = () => ({
  root: {
    textAlign: "center",
  },
});
